export default __webpack_public_path__ + "a397dccfb4e55774f65dd5d1ef5741e6.svg";